import { WizardStepBar } from "../../../../common/wizard/WizardStepBar";
import {
  REQUEST_WIZARD_STEP_KEYS,
  useRequestStepLabel,
  useRequestStepShortLabel,
  type RequestStep,
} from "./requestWizardSteps";

interface Props {
  currentStep: RequestStep;
  navigateToStep: (step: RequestStep) => void;
}

export const RequestWizardNav = ({ currentStep, navigateToStep }: Props) => (
  <WizardStepBar
    steps={REQUEST_WIZARD_STEP_KEYS}
    currentStep={currentStep}
    navigateToStep={navigateToStep}
    stepLabel={useRequestStepLabel()}
    stepShortLabel={useRequestStepShortLabel()}
  />
);
